import "@mux/mux-player";
export default {
  name: "VideoPlayer",
  props: {
    playbackId: {
      type: String,
      required: true
    },
    videoTitle: {
      type: String,
      required: false
    },
    accentColor: {
      type: String,
      default: "#4a4949"
    },
    primaryColor: {
      type: String,
      default: "#f6f6f6"
    },
    secondaryColor: {
      type: String,
      default: "#060606"
    },
    posterImageUrl: {
      type: String,
      default: ""
    },
    muted: {
      type: Boolean,
      default: false
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    loop: {
      type: Boolean,
      default: false
    },
    controls: {
      type: Boolean,
      default: true
    }
  }
};